import React, { Component } from 'react';
import First from './components/first';
import Second from './components/second';
import Third from './components/third';
import Fourth from './components/fourth';
import Fifth from './components/fifth';
import Bottom from './components/bottom';
import Hearder from './components/header';
import {SectionsContainer, Section,Header, Footer,ReactFullpage} from '../node_modules/react-fullpage';
import './config';
import '../node_modules/fullpage.js/dist/fullpage'

export  default  class App extends Component {
  constructor(props){
    super(props)
    this.state={
      isMobile:false,
    }
  }
  componentDidMount(){
    window.location.href="/#sectionOne"
    //window.location.url.contain('mondonational.com');
    // this.toFIrst()
  }
  toFIrst(){
    window.location.href="/#sectionOne"
  }
  

  render() {
    let options={
      sectionClassName:     'section',
      anchors:              ['sectionOne', 'sectionTwo', 'sectionThree','sectionFour','sectionFive'],
      scrollBar:            false,
      navigation:           true,
      verticalAlign:        false,
      arrowNavigation:      true,
      sectionsColor:['white'],
      lazyLoading:true,
    }
    
    return (
      <div>
        {!global.constants.isMobile&&
        <div>
          <Header>
            <Hearder/>
          </Header>
          <SectionsContainer  className="App" {...options}>
          <Section>
            <First/>
          </Section>
          <Section>
            <Second/>
          </Section>
          <Section>
            <Third/>
          </Section>
          <Section>
            <Fourth/>
          </Section> 
          <Section>
            <Fifth/>
            <Bottom/>
          </Section>
          </SectionsContainer>
        </div>}
        {global.constants.isMobile&&
        <div>
            <Hearder/>
          <div className="App" >
            <First/>
            <Second/>
            <Bottom/>
          </div>
        </div>}
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/App.js